import Annotation from 'components/Annotation'
import { AnnotationTextMarker as TM } from 'components/Annotation/AnnotationTextMarker'
import { CircleAnnotation } from 'components/Annotation/CircleAnnotation'
const isMobile = window.innerWidth < 712

export const geneva_data: CityData = {
  name: 'Genf',
  bfsid: '6621',
  sat_images: [
    {
      label: 'Tiefer Status - Les Pâquis',
      image: isMobile
        ? require('../../../Content/Maps/maps_6621_sat_poor_mob.jpg')
        : require('../../../Content/Maps/maps_6621_sat_poor.jpg'),
    },
    {
      label: 'Hoher Status - Vieille-Ville',
      image: isMobile
        ? require('../../../Content/Maps/maps_6621_sat_rich_mob.jpg')
        : require('../../../Content/Maps/maps_6621_sat_rich.jpg'),
    },
  ],
  elements: [
    {
      id: 'zh_1',
      text: (
        <>
          <p>
            In der Gemeinde Genf selbst ist die Trennung zwischen den
            Wohnvierteln der Armen und der Reichen weniger ausgeprägt als in den
            deutschsprachigen Grossstädten. Die Verteilung gleicht oft einem
            Mosaik, mit einer Mischung aus Einfamilienhäusern und Sozialbauten.
          </p>
        </>
      ),
      annotations: [
        {
          content: <Annotation priority={3}>Les Franchises</Annotation>,
          position: { x: 6, y: 35 },
          position_mobile: { x: 6, y: 38 },
        },
        {
          content: <Annotation priority={3}>Eaux-Vives</Annotation>,
          position: { x: 60, y: 48 },
          position_mobile: { x: 53, y: 50 },
        },
        {
          content: <Annotation priority={3}>Petit-Saconnex</Annotation>,
          position: { x: 40, y: 28 },
          position_mobile: { x: 32, y: 31 },
        },
        {
          content: <Annotation priority={3}>Les Pâquis</Annotation>,
          position: { x: 60, y: 40 },
          position_mobile: { x: 59, y: 44 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_6621_all_mob.jpg')
        : require('../../../Content/Maps/maps_6621_all.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_6621_all_mob_dm.jpg')
        : require('../../../Content/Maps/maps_6621_all_dm.jpg'),
    },
    {
      id: 'zh_2',
      text: (
        <>
          <p>
            Die Bewohnerinnen und Bewohner der <TM prio={2}>Altstadt</TM>{' '}
            gehören zu den reichsten Menschen in Genf. Die berühmte Rue des
            Granges ist mit ihren Herrenhäusern ein Symbol dafür.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 30 : 60}
              angle={isMobile ? 120 : 230}
            >
              Altstadt
            </CircleAnnotation>
          ),
          position: { x: 56, y: 56 },
          position_mobile: { x: 57, y: 56 },
        },
        {
          content: <Annotation priority={3}>Les Franchises</Annotation>,
          position: { x: 6, y: 35 },
          position_mobile: { x: 6, y: 38 },
        },
        {
          content: <Annotation priority={3}>Eaux-Vives</Annotation>,
          position: { x: 60, y: 48 },
          // position_mobile: { x: 53, y: 50 },
        },
        {
          content: <Annotation priority={3}>Petit-Saconnex</Annotation>,
          position: { x: 40, y: 28 },
          position_mobile: { x: 32, y: 31 },
        },
        {
          content: <Annotation priority={3}>Les Pâquis</Annotation>,
          position: { x: 60, y: 40 },
          position_mobile: { x: 59, y: 44 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_6621_rich_mob.jpg')
        : require('../../../Content/Maps/maps_6621_rich.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_6621_rich_mob_dm.jpg')
        : require('../../../Content/Maps/maps_6621_rich_dm.jpg'),
    },
    {
      id: 'zh_3',
      text: (
        <>
          <p>
            Vereinzelte Konzentrationen von ärmeren Menschen finden sich in
            bestimmten Bereichen des Viertels{' '}
            <TM prio={3}>Saint-Jean Charmilles</TM> oder{' '}
            <TM prio={3}>Pâquis.</TM>
          </p>
        </>
      ),
      annotations: [
        {
          content: <Annotation priority={3}>Les Franchises</Annotation>,
          position: { x: 6, y: 35 },
          // position_mobile: { x: 6, y: 38 },
        },
        {
          content: <Annotation priority={3}>Eaux-Vives</Annotation>,
          position: { x: 60, y: 48 },
          position_mobile: { x: 53, y: 50 },
        },
        {
          content: <Annotation priority={3}>Petit-Saconnex</Annotation>,
          position: { x: 40, y: 28 },
          position_mobile: { x: 32, y: 31 },
        },

        {
          content: (
            <CircleAnnotation
              size={isMobile ? 50 : 90}
              angle={isMobile ? 90 : 60}
            >
              Saint-Jean Charmilles
            </CircleAnnotation>
          ),
          position: { x: 30, y: 41 },
          position_mobile: { x: 23, y: 45 },
        },
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 40 : 55}
              angle={isMobile ? 330 : 280}
            >
              Les Pâquis
            </CircleAnnotation>
          ),
          position: { x: 57, y: 37 },
          position_mobile: { x: 57, y: 40 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_6621_poor_mob.jpg')
        : require('../../../Content/Maps/maps_6621_poor.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_6621_poor_mob_dm.jpg')
        : require('../../../Content/Maps/maps_6621_poor_dm.jpg'),
    },
  ],
}
